import { IParamsGetNewTumRegister } from 'app/api/newTumRegister/model'

export const NewTumRegisterKeys = {
  allNewTumRegister: ['NewTumRegister'] as const,
  listNewTumRegisters: () =>
    [...NewTumRegisterKeys.allNewTumRegister, 'listNewTumRegisters'] as const,
  listNewTumRegister: (filter?: IParamsGetNewTumRegister) =>
    [...NewTumRegisterKeys.listNewTumRegisters(), { filter }] as const,

  countStatusNewTumRegisters: () =>
    [
      ...NewTumRegisterKeys.allNewTumRegister,
      'countStatusNewTumRegisters',
    ] as const,
  countStatusNewTumRegister: (filter?: { userId?: number }) =>
    [...NewTumRegisterKeys.countStatusNewTumRegisters(), { filter }] as const,
}
